import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, Dropdown} from "react-bootstrap";
import { FaPlus, FaRegEdit, FaSearch, FaFilter, FaTrash, FaEraser } from "react-icons/fa";
import api from "../../services/api";
import { hasPerm, getCurrentUser} from '../../common/utils';
import Paginacao from '../../common/pagination';
import Swal from 'sweetalert2';
import AsyncSelect from 'react-select/async';
import { IMaskInput } from "react-imask";

class Consultores extends Component {
    constructor(props) {
        super(props);
        this.onChangeNome = this.onChangeNome.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);
        this.buscaConsultores = this.buscaConsultores.bind(this);

        this.state = {
            listRegistros: [],
            error: "",
            busca: "",
            page_numb: 1,
            loading: true,
            nome: "",
            email: "",
            telefone: "",
            programa_id: "",
            programa_nome: "",
            estado: [],
        };
    }

    componentDidMount(){
        let dados_usuario = getCurrentUser();
        const programa_id = (dados_usuario['ambiente_programa_id']) ? dados_usuario['ambiente_programa_id'] : '';

        this.setState({
            filtro_programa_id: programa_id
        }, () => {
            this.consultaConsultores()
        });

    }

    consultaConsultores(page_numb = 1) {
        let dados_usuario = getCurrentUser();
        
        this.setState({ loading: true });

        let filtros = `?page=${page_numb}`;

        if (dados_usuario['ambiente_programa_id']) {
            filtros += `&programa_id=${dados_usuario['ambiente_programa_id']}`;
        } else if(this.state.programa_id){
            filtros += '&programa_id='+this.state.programa_id
        }

        if (this.state.nome) {
            filtros += '&nome=' + this.state.nome;
        }

        if (this.state.email) {
            filtros += '&email=' + this.state.email;
        }
        
        if (this.state.telefone) {
            filtros += '&telefone=' + this.state.telefone;
        }

        if (Array.isArray(this.state.estado) && this.state.estado.length > 0) {
            const siglas = this.state.estado.map(s => s.value).join(',');
            filtros += '&estado=' + encodeURIComponent(siglas);
        }

        api.get('/consultores/' + filtros)
            .then(response => {
                this.setState({
                    loading: false,
                    error: "",
                    listRegistros: response.data,
                    page_numb
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar Consultores, tente novamente.';

                if (error.response && error.response.status === 500) {
                    erro_msg = 'Servidor indisponível no momento';
                } else if (error.response && error.response.status === 403) {
                    erro_msg = 'Você não tem permissão para acessar essa área';
                }

                this.setState({
                    loading: false,
                    error: erro_msg
                });
            });
    }

    renderRows = () => {
        if('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0){
            return this.state.listRegistros.results.map((item) =>
            <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.nome}</td>
                <td>{item.email}</td>
                <td>{item.telefone}</td>
                <td>{item.dados_programa.nome}</td>
                <td className="text-end">
                    <Button variant="light" href={"/consultores/edit/" + item.id} size="sm">
                        <FaRegEdit /> Editar
                    </Button> 
                    <Button className="ms-3" variant="danger" size="sm" onClick={() => this.handleDelete(item.id)}>
                        <FaTrash/>
                    </Button>   
                </td>
            </tr>
            );
        }        

        return (
            <tr>
                <td colSpan={3}>Nenhum consultor encontrado</td>
            </tr>
        );
    };

    handleDelete = (id) => {
        Swal.fire({
            title: 'Tem certeza?',
            text: "Essa ação não poderá ser desfeita!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                api.delete(`/consultores/${id}`)
                .then(response => {
                    Swal.fire(
                        'Excluído!',
                        'Consultor foi excluído com sucesso.',
                        'success'
                    );
                    this.consultaConsultores(this.state.busca, this.state.page_numb);
                })
                .catch(error => {
                    Swal.fire(
                        'Erro!',
                        'Ocorreu um problema ao excluir consultor.',
                        'error'
                    );
                });
            }
        });
    }

    onChangeNome(e) {
        this.setState({
            nome: e.target.value,
        });
    }

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaConsultores(num_page)
    };

    buscaConsultores(e) {
        e.preventDefault();

        this.setState({
            loading: true,
        });
        
        this.consultaConsultores(1)
    };

    limpaFiltro = () => {
        this.setState({
            nome: '',
            email: '',
            telefone: '',
            programa_id: '',
            estado: [],
        }, () => {
            this.consultaConsultores(1);
        })  
    }

    carregaProgramas = async (inputValue) => {
        try {
            const response = await api.get(`/programas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    };

    carregaEstados = async (inputValue) => {
        const estadosBrasileiros = [
            { value: 'AC', label: 'Acre' },
            { value: 'AL', label: 'Alagoas' },
            { value: 'AM', label: 'Amazonas' },
            { value: 'AP', label: 'Amapá' },
            { value: 'BA', label: 'Bahia' },
            { value: 'CE', label: 'Ceará' },
            { value: 'DF', label: 'Distrito Federal' },
            { value: 'ES', label: 'Espírito Santo' },
            { value: 'GO', label: 'Goiás' },
            { value: 'MA', label: 'Maranhão' },
            { value: 'MT', label: 'Mato Grosso' },
            { value: 'MS', label: 'Mato Grosso do Sul' },
            { value: 'MG', label: 'Minas Gerais' },
            { value: 'PA', label: 'Pará' },
            { value: 'PB', label: 'Paraíba' },
            { value: 'PR', label: 'Paraná' },
            { value: 'PE', label: 'Pernambuco' },
            { value: 'PI', label: 'Piauí' },
            { value: 'RJ', label: 'Rio de Janeiro' },
            { value: 'RN', label: 'Rio Grande do Norte' },
            { value: 'RS', label: 'Rio Grande do Sul' },
            { value: 'RO', label: 'Rondônia' },
            { value: 'RR', label: 'Roraima' },
            { value: 'SC', label: 'Santa Catarina' },
            { value: 'SP', label: 'São Paulo' },
            { value: 'SE', label: 'Sergipe' },
            { value: 'TO', label: 'Tocantins' },
        ];

        const filtered = estadosBrasileiros.filter(estado =>
            estado.label.toLowerCase().includes((inputValue || '').toLowerCase()) ||
            estado.value.toLowerCase().includes((inputValue || '').toLowerCase())
        );

        return filtered;
    };

    handleChangeFiltros = (event, fieldName) => {
        if(fieldName == 'programa_id') {
            this.setState(prevState => ({
                programa_id: event.value, 
                programa_nome: event.label, 
            }));
        } else if (fieldName == 'estado') {
            this.setState({ estado: event || [] });
        }
        else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    render() {
        if (!hasPerm('view_consultores')) {
            return <Navigate to='/sem-permissao' />
        }

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Consultores</h4>
                    </Col>
                    <Col sm={6} lg={6} className="text-end">
                        <Button variant="secondary" href="/consultores/add" className="mb-3" size="sm">
                            <FaPlus /> Adicionar Consultores
                        </Button>
                    </Col>
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <Row>
                            <Col sm={12} lg={12} className="mb-3 d-flex justify-content-end">
                                <Dropdown className="d-inline">
                                    <Dropdown.Toggle variant="light" size="sm">
                                        <FaFilter /> Filtrar
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <div className="drop-filter">
                                            <Form method="get" onSubmit={this.buscaConsultores}>
                                                <Row>
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Nome</Form.Label>                                  
                                                            <Form.Control
                                                                type="text"
                                                                name="nome"
                                                                value={this.state.nome}
                                                                onChange={this.onChangeNome}
                                                                placeholder="Nome"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Programa <span>*</span></Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={this.carregaProgramas}
                                                                defaultOptions
                                                                name="programa_id"
                                                                placeholder={"Buscar programa..."}
                                                                noOptionsMessage={() => "Nenhum programa encontrado" }
                                                                onChange={(e) => this.handleChangeFiltros(e, "programa_id")}
                                                                value={this.state.programa_id ? {value: this.state.programa_id, label: this.state.programa_nome,}: null}
                                                                styles={{
                                                                    option: (provided) => ({
                                                                        ...provided,
                                                                        fontSize: '12px', 
                                                                    }),
                                                                }}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Estados</Form.Label>
                                                            <AsyncSelect
                                                                isMulti
                                                                cacheOptions
                                                                defaultOptions
                                                                loadOptions={this.carregaEstados}
                                                                placeholder="Buscar estados..."
                                                                noOptionsMessage={() => "Nenhum estado encontrado"}
                                                                onChange={(e) => this.handleChangeFiltros(e, "estado")}
                                                                value={this.state.estado}
                                                                styles={{
                                                                    option: (provided) => ({
                                                                        ...provided,
                                                                        fontSize: '12px',
                                                                    }),
                                                                }}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Button type="submit" variant="light" size="sm">
                                                    <FaSearch /> Filtrar
                                                </Button>

                                                <Button type="button" variant="light" size="sm" onClick={() => this.limpaFiltro()}>
                                                    <FaEraser /> Limpar Filtro
                                                </Button>
                                            </Form>
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Col>
                        </Row>    

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Nome</th>
                                    <th>Email</th>
                                    <th>Telefone</th>
                                    <th>Programa</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={3}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={3}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                                       
                            </tbody>
                        </Table>       
                        { 
                            'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 && 
                            <Paginacao dados={this.state.listRegistros} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }                    
                    </Card.Body>                
                </Card>
            </div>
        );
    }
}

export default withRouter(Consultores);